export function formatSocialSecurityNumber(input: string): string {
    if (!input || input.includes('.')) return input;
    const part1 = input.slice(0, 2);
    const part2 = input.slice(2, 4);
    const part3 = input.slice(4, 6);
    const part4 = input.slice(6, 9);
    const part5 = input.slice(9, 11);

    return `${part1}.${part2}.${part3}-${part4}.${part5}`;
}
